import {
  GetCoursesResponse,
  CourseRequest,
} from "../../../types/api/courses.type";
import { QueryParam, ResourceId } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CoursesService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCoursesResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetCoursesResponse>(
      `v1/courses?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
  async add(body: CourseRequest): Promise<ResourceId> {
    const response = await httpClient.post<CourseRequest, ResourceId>(
      "v1/courses",
      body,
    );
    return response;
  },
  async update(courseId: number, body: CourseRequest): Promise<void> {
    await httpClient.put(`v1/courses/${courseId}`, body);
  },
  async delete(courseId: number): Promise<void> {
    await httpClient.delete(`v1/courses/${courseId}`);
  },
};

export default CoursesService;
